import React, { useState } from "react";
import { isNativeApp } from "../../platform/native";

/**
 * The Android app's download link. Inside app 0.5.0 and earlier the web view
 * dropped downloads, so the app also offers the link to paste into Chrome.
 */
const ApkLink = ({ children, ...props }) => {
  const [copied, setCopied] = useState(false);
  const link = (
    <a className="text-primary underline underline-offset-2" download {...props}>
      {children}
    </a>
  );
  if (!isNativeApp()) return link;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(new URL(props.href, window.location.href).href);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };
  return (
    <>
      {link}{" "}
      <button type="button" onClick={copy} className="text-sm text-muted-foreground underline underline-offset-2">
        {copied ? "Link copied: paste it into Chrome" : "Copy link"}
      </button>
    </>
  );
};

export default ApkLink;
